<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="className"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M11.8747 4H8.12467L7.90997 7.00571C7.82335 8.21846 8.78387 9.25 9.9997 9.25C11.2155 9.25 12.176 8.21846 12.0893 7.00572L11.8747 4Z"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.12536 4H5.3013C4.55482 4 3.92194 4.5489 3.81637 5.28787L3.60243 6.78547C3.41661 8.08623 4.42594 9.25 5.73991 9.25C6.87269 9.25 7.81289 8.37457 7.8936 7.24466L8.12536 4Z"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.699 4H11.875L12.1068 7.24466C12.1875 8.37457 13.1276 9.25 14.2604 9.25C15.5744 9.25 16.5837 8.08623 16.3979 6.78547L16.184 5.28787C16.0785 4.5489 15.4455 4 14.699 4Z"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4 8.5V14.5C4 15.3284 4.67157 16 5.5 16H8.5V13.75C8.5 12.9216 9.17155 12.25 10 12.25C10.8284 12.25 11.5 12.9216 11.5 13.75V16H14.5C15.3284 16 16 15.3284 16 14.5V8.5"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'AgencyWorkIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
